import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientFirstHeadSaveEmailMutation } from 'api/generated/graphql';
import { parseLegalClientFirstHeadEntity, useError } from 'api/helpers';

interface Props {
  email: string;
  versionNumber: number;
  reason: string;
}

export const useLegalClientFirstHeadSaveEmail = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientFirstHeadSaveEmailMutation();

  const error = useError(apolloError);

  return {
    legalClientFirstHead: data?.saveEmail
      ? parseLegalClientFirstHeadEntity(data.saveEmail)
      : undefined,
    loading,
    error,
    saveEmail: useCallback(
      async (id: string, input: Props) => {
        const res = await handle({ variables: { id, input } });
        return res.data?.saveEmail
          ? parseLegalClientFirstHeadEntity(res.data?.saveEmail)
          : undefined;
      },
      [handle]
    ),
  };
};
